import { Component, OnInit } from '@angular/core';
import { Constanst } from '../../constants/constans.component';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  logoColegioIngenieros = Constanst.LOGO_COLEGIO_INGENIEROS;
  logoDatalaing = Constanst.LOGO_DATALAING;
  flag: boolean = false;

  constructor(

  ) { }

  ngOnInit(): void {
  }



}
